import { useContext, useEffect, useMemo } from 'react';
import classNames from 'classnames';
import { changeLibraryColors } from '@bpm-web-app/utils';
import { useCurrentUser } from '@bpm-web-app/swr-hooks';
import styles from './library-tabs.module.css';
import { Library, LibraryTabsContext } from '../../../../utils/src/lib/library-tabs.context';

// eslint-disable-next-line @typescript-eslint/dot-notation
export const SHOW_WHITE_LABEL = process.env['NEXT_PUBLIC_RELEASE_STAGE'] !== 'production';

export function LibraryTabs() {
    const { library, setLibrary, isSwitcherVisible } = useContext(LibraryTabsContext);
    const { data } = useCurrentUser();

    const tabs = useMemo(
        () => [
            {
                id: Library.Main,
                label: 'Open Format',
            },
            {
                id: Library.Latin,
                label: 'Latino',
            },
            SHOW_WHITE_LABEL || data?.data?.user?.beta_tester === true ?
                {
                    id: Library.Artist,
                    label: 'White Label',
                } : undefined
        ].filter(Boolean),
        [data]
    );

    useEffect(() => {
        changeLibraryColors({ library });
    }, [library]);

    if (!isSwitcherVisible) {
        return null;
    }

    return (
        <div role="tablist" className={classNames(styles['library-tabs'], 'spacing__window--left')}>
            {tabs.map((tab) => (
                <button
                    key={tab.id}
                    className={classNames(styles['library-tabs__tab'], {
                        [styles['library-tabs__tab--active']]: library === tab.id,
                    })}
                    type="button"
                    role="tab"
                    onClick={() => setLibrary(tab.id)}
                    aria-selected={library === tab.id}
                >
                    {tab.label}
                </button>
            ))}
        </div>
    );
}

export default LibraryTabs;
